import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {InternalService} from '../../services/internal.service';
import {ApiService} from '../../services/api.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {element} from 'protractor';


@Component({
  selector: 'upload-file',
  templateUrl: './uploadFileModal.component.html',
  styleUrls: ['./uploadFileModal.component.css']
})
export class UploadFileModalComponent implements OnInit {
  myForm: FormGroup;
  filesList: any = [];

  constructor(
    public internalService: InternalService,
    public apiService: ApiService,
    public dialogRef: MatDialogRef<UploadFileModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) {
  }

  ngOnInit() {
    this.myForm = new FormGroup({
      file: new FormControl('', [Validators.required])
    });
    this.getall();

  }


  getall() {
    this.apiService.apiCall('get', '/api/gallery/getall', {})
      .subscribe((response: any) => {
        // console.log(response);
        this.filesList = response.res;
      });
  }


  actionFunction() {
    // this.modalData.function();
    // console.log(this.modalData);

    this.closeModal();
  }

  closeModal() {
    // console.log(this.modalData);

    this.dialogRef.close();
  }

  onSelectFile(event) {
    // console.log(event);
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.myForm.get('file').setValue(file);
    }
     this.submit();
  }

  submit() {
    const formData = new FormData();
    formData.append('file', this.myForm.get('file').value);
    this.apiService.AddFile(formData).subscribe((response: any) => {
      // console.log(response);
      if (response.stu === 1) {
        this.filesList.push(response.res);
        const item= document.getElementById('uploadedFile') as HTMLSelectElement;
        item.value = '';
      }
    });
  }

  chooseFile(uniqueName, name) {
    this.modalData.file = uniqueName;
    this.modalData.name = name;
    this.filesList.forEach((element) => {
      if (document.getElementById(element.uniqueName).classList.contains('selectedBox')) {
        document.getElementById(element.uniqueName).classList.remove('selectedBox');
      }
    });
    document.getElementById(uniqueName).classList.add('selectedBox');
  }

  deleteFile(id) {
    this.apiService.apiCall('delete', '/api/gallery/deleteFile/' + id, {})
      .subscribe((response: any) => {
        // console.log(response);
        if (response.stu === 1) {
          const array = this.filesList.filter(item => item.uniqueName !== id);
          this.filesList = array;
        }

      });
  }
}
